<div class="grid grid-cols-2 gap-1.5" [ngClass]="getGridClasses()">
  @for (hairdresser of hairdresserResponse().data | paginate:{
  itemsPerPage: hairdresserResponse().limit,
  totalItems: hairdresserResponse().totalElements,
  currentPage: hairdresserResponse().currentPage
  }; track $index) {
  <a [routerLink]="['/hairdressers', hairdresser.username]"
    class="text-sm overflow-hidden lg:border rounded-xl lg:p-1  shadow-lg lg:shadow-none lg:hover:shadow-lg transition duration-300">
    <div class="relative h-36 xl:h-44 w-auto rounded-lg overflow-hidden">
      <img [ngSrc]="hairdresser.cover_link || IMAGE_PLACEHOLDER" [alt]="hairdresser.firstname" fill
        class="object-cover bg-gray-100 border border-gray-200 rounded-lg">
    </div>
    <div class="p-2 flex items-center gap-2">
      <div
        class="w-8 h-8 lg:w-9 lg:h-9 aspect-square border-2 border-main-500 rounded-full relative bg-gray-200 overflow-hidden">
        <img [ngSrc]="hairdresser.pp_link || AVATAR_PLACEHOLDER" [alt]="hairdresser.firstname"
          class="w-full h-full bg-gray-100 object-cover" fill>
      </div>
      <div class="flex flex-col w-[calc(100%-36px)]">
        <h3 class="truncate max-w-[100px] lg:max-w-[120px] overflow-hidden text-xs">{{
          hairdresser.username }}</h3>
        <div class="line-clamp-1 max-w-[100px] lg:max-w-[150px] text-xs">{{ hairdresser.activity_area }}</div>
      </div>
    </div>
  </a>
  }
</div>

@if (hairdresserResponse().totalPages > 1) {
<pagination-controls [nextLabel]="'HAIRDRESSERS.NEXT' | translate" [previousLabel]="'HAIRDRESSERS.PREVIOUS' | translate"
  (pageChange)="onPageChange($event)" class="pagination" />
}